import React, { useState, useEffect, Fragment } from "react";
import ReactPaginate from "react-paginate";
import { getRecordsText } from "utils/utils";

const Pagination = ({
  itemsPerPage = 10,
  totalCount = 0,
  itemOffset = 0,
  listData = [],
  onPageChange = () => {},
  setItemOffset = () => {},
}) => {
  const [pageCount, setPageCount] = useState(2);

  useEffect(() => {
    setPageCount(Math.ceil(totalCount * 0.1));
  }, [totalCount, itemsPerPage]);

  const handlePageClick = (event) => {
    const newOffset = event.selected * 1;
    onPageChange(newOffset);
    setItemOffset(newOffset);
  };

  return (
    <Fragment>
      <hr />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="pagination pagination-primary float-right">
                <ReactPaginate
                  breakLabel="..."
                  nextLabel="next >"
                  onPageChange={(e) => handlePageClick(e)}
                  pageCount={pageCount}
                  previousLabel="< previous"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  containerClassName="pagination"
                  activeClassName="active"
                  forcePage={itemOffset}
                />
              </div>
              <div className="pt-2">
                {getRecordsText(
                  totalCount,
                  itemOffset,
                  itemsPerPage,
                  listData.length
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Pagination;
